import React, { FC } from 'react';
import classNames from 'classnames';
import { OrderSelectBaseLayout } from '@component/OrderSelectBaseLayout';
import { OrderPartsHelpFeatherinside } from '@component/OrderPartsHelp';
import {
    FeatherinsideTabProductCategoryListContainer,
    FeatherinsideOrderProductCategoryListContainer,
} from '@container/Featherinside';
import { FeatherinsideCantSelectDialogContainer } from '@container/Dialog';
import {
    OrderPartsImg,
    OnSelectProductHandler,
} from '@app/react/uikit';
import { PartsProduct } from '@app/react/const/type';
import { useMediaDesktop } from '@app/react/common/useMedia';

const PREFIX = 'order-featherinside-select';
const PREFIX_HEADER = `${PREFIX}__header`;
const PREFIX_BODY = `${PREFIX}__body`;
const PREFIX_FOOTER = `${PREFIX}__footer`;

export interface OrderFeatherinsideSelectComponentProps {
    selectedProduct: PartsProduct | null;
    onSelectProduct: OnSelectProductHandler;
    allDisabled?: boolean;
    isHelpOpen: boolean;
    handleHelpOpen: () => void;
    handleHelpClose: () => void;
}

export const OrderFeatherinsideSelectComponent: FC<OrderFeatherinsideSelectComponentProps> = (
    props,
) => {
    const {
        selectedProduct,
        onSelectProduct,
        allDisabled = false,
        isHelpOpen,
        handleHelpOpen,
        handleHelpClose,
    } = props;

    const isDesktop = useMediaDesktop();

    const rootClassName = {
        root: classNames(PREFIX),
        header: classNames(PREFIX_HEADER),
        body: classNames(PREFIX_BODY),
        footer: classNames(PREFIX_FOOTER),
    };

    return (
        <>
            <OrderSelectBaseLayout
                classNames={rootClassName}
                header={isDesktop && (
                    <OrderPartsImg
                        partsName="羽中加工"
                        showHelpBtn
                        onHelpClick={handleHelpOpen}
                    />
                )}
                body={isDesktop
                    ? (
                        <FeatherinsideTabProductCategoryListContainer
                            selectedProduct={selectedProduct}
                            onSelectProduct={onSelectProduct}
                            allDisabled={allDisabled}
                        />
                    )
                    : (
                        <FeatherinsideOrderProductCategoryListContainer
                            selectedProduct={selectedProduct}
                            onSelectProduct={onSelectProduct}
                            allDisabled={allDisabled}
                        />
                )}
            >
                <FeatherinsideCantSelectDialogContainer />
            </OrderSelectBaseLayout>
            <OrderPartsHelpFeatherinside
                isOpen={isHelpOpen}
                handleOpen={handleHelpOpen}
                handleClose={handleHelpClose}
            />
        </>
    );
};
